"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _CwToolbar = _interopRequireDefault(require("./CwToolbar.scss"));

var CwToolbar =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2.default)(CwToolbar, _Component);

  function CwToolbar() {
    (0, _classCallCheck2.default)(this, CwToolbar);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(CwToolbar).apply(this, arguments));
  }

  (0, _createClass2.default)(CwToolbar, [{
    key: "render",
    value: function render() {
      return _react.default.createElement("div", {
        "data-cwid": this.props.cwId,
        className: _CwToolbar.default.toolbar
      }, _react.default.createElement("div", {
        className: _CwToolbar.default.overflowButtons
      }, this.props.overflowButtons), this.props.rightButtons ? _react.default.createElement("div", {
        className: _CwToolbar.default.rightButtons
      }, this.props.rightButtons) : null);
    }
  }]);
  return CwToolbar;
}(_react.Component);

exports.default = CwToolbar;
CwToolbar.propTypes = {
  /**
   * Connectwise element id to be used as unique identifier
   */
  cwId: _propTypes.default.string,
  overflowButtons: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.element), _propTypes.default.element]),
  rightButtons: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.element), _propTypes.default.element])
};